module.exports = __webpack_public_path__ + "static/img/Kindle_Young.a80e0fb7.jpg";